// @flow

import SecurityContext from './SecurityContext';
import POSType from 'PMT/constants/POSType';
import RestaurantStore from 'stores/RestaurantStore';
import OrderSettingsStore from 'stores/OrderSettingsStore';

export default class RestaurantMenuPermissions {
  canRead(proRole: ProRole = null): boolean {
    return SecurityContext.havePermission('restaurantMenu.settings', proRole);
  }

  canEdit(proRole: ProRole = null): boolean {
    return SecurityContext.havePermission(
      'restaurantMenu.settings.canEditSettings',
      proRole
    );
  }

  canEditAvailabilityProducts(proRole: ProRole = null): boolean {
    return SecurityContext.havePermission(
      'restaurantMenu.settings.canEditAvailabilityProducts',
      proRole
    );
  }

  canEditOptions(proRole) {
    const canEdit = this.canEdit(proRole);
    const menuManagedByPos = OrderSettingsStore.getOrderSettings()
      .menuManagedByPos;
    const pos = RestaurantStore.getRestaurant().pos;
    return (
      canEdit &&
      (!menuManagedByPos ||
        // csi does not handle options on its side, we allow create them from here
        pos === POSType.POS_CSI)
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/utils/permissions/RestaurantMenuPermissions.js